import apiClient from './api';

export interface NotificationItem {
  id: number;
  tenant_id: number;
  type: string;
  title: string;
  message: string;
  link: string | null;
  is_read: boolean;
  created_at: string;
}

export const notificationsApi = {
  list: () => apiClient.get<NotificationItem[]>('/notifications'),
  unreadCount: () => apiClient.get<{ count: number }>('/notifications/unread-count'),
  markRead: (id: number) => apiClient.patch(`/notifications/${id}/read`),
  markAllRead: () => apiClient.post('/notifications/mark-all-read'),
};
